if (module.hot && window.location.port !== '8000') {
    module.hot.accept();
}

import 'modernizr';
import 'util/detect';



// WEBPACK FOOTER //
// ./migros-iqm-rialto/assets/src/js/app/main/index.js